"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var PromptablePropInterface = {
  onConfirm: _propTypes.default.func.isRequired,
  onReject: _propTypes.default.func.isRequired
};
var _default = PromptablePropInterface;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/decorators/PromptablePropInterface.js
// module id = 624
// module chunks = 5 6